import {
  CheckForTimelineItemTimeConflictArgs,
  getNextAndPreviousTimelineItems,
  sortTimelineItems,
} from '@modules/timetable';
import { TimelineItemTypeType } from '@app-types/timetable';

export const checkForTimelineItemTimeConflict = ({
  filterField,
  timelineItems,
  item,
  resolve,
  startTime,
  endTime,
  confirmChange,
}: CheckForTimelineItemTimeConflictArgs) => {
  // Get timeline items with the same location / lecturer
  const timelineItemsWithSameLocation = timelineItems.filter(
    (timelineItem) =>
      (timelineItem.itemType === TimelineItemTypeType.subject ||
        timelineItem.itemType === TimelineItemTypeType.extra) &&
      timelineItem[filterField] === item[filterField] &&
      timelineItem.id !== item.id,
  );

  // If nothing found, no conflicts
  if (timelineItemsWithSameLocation.length === 0) {
    return resolve(true);
  }

  // Sort the timeline items according to start time
  const sortedTimelineItems = sortTimelineItems({
    timelineItems: [
      ...timelineItemsWithSameLocation,
      {
        ...item,
        startTime,
        endTime,
      },
    ],
  });

  // Get the next and previous timeline items for the current item
  const { previousItem, nextItem } = getNextAndPreviousTimelineItems({
    timelineItems: sortedTimelineItems,
    currentTimelineItemId: item.id,
  });

  if (previousItem && previousItem.endTime > startTime) {
    // If conflicts with the previous item
    return confirmChange({
      resolve,
      conflictingItemTitle: previousItem.title,
      subjectName: previousItem.subjectName,
      batchName: previousItem.batchName,
      batchClassName: previousItem.batchClassName,
    });
  }
  if (nextItem && endTime > nextItem.startTime) {
    // If conflicts with the current item
    return confirmChange({
      resolve,
      conflictingItemTitle: nextItem.title,
      subjectName: previousItem.subjectName,
      batchName: previousItem.batchName,
      batchClassName: previousItem.batchClassName,
    });
  }

  return resolve(true);
};
